export default __webpack_public_path__ + "static/media/workouttimes_1@3x.213b72a6.jpg";